<rask-header size="2" underline>Produktionsmål & plan</rask-header>
@if (!isDetailMode()) {
  <rask-selector
    aid="selectProduktionsomrade"
    class="col-lg-3 col-sm-5"
    label="PRODUKTIONSOMRÅDE"
    [reverseLookup]="false"
    [viewFormatter]="poFormatter"
    [groupBy]="poGroupBy"
    [(ngModel)]="produktionsomrade"
    [values]="produktionsomraden">
  </rask-selector>
}
<rask-datepicker
  [ngClass]="{'col-lg-2 col-sm-6': !isDetailMode(), 'col-lg-3 col-sm-6':isDetailMode()}"
  [(ngModel)]="period"
  [minDate]="minDate"
  [allowInvalidInput]="true"
  aid="produktionsmalPeriod"
  [onlyMonths]="true"
  label="PERIOD">
</rask-datepicker>
<rask-button class="p-0 ms-2" color="secondary" [disabled]="!canShow()" (click)="showGraph()" aid="viewUpdateButton">
  {{ produktionsmalPlan ? "Uppdatera" : "Visa"}}
</rask-button>
@if (isDetailMode()) {
  @if (produktionsmalPlan) {
    <rask-input
      class="col-3 offset-lg-2"
      label="Visar"
      [readonly]="true"
      value="{{ resultProduktionsomrade.namn }} i {{ produktionsmalPlan.period | date:'LLLL' | lowercase }}">
    </rask-input>
  }
  @if (produktionsmalPlan) {
    <rask-input
      class="col-2"
      label="Hämtat"
      [readonly]="true"
      value="{{ produktionsmalPlan.responseDate | date:'HH:mm d MMM'}}">
    </rask-input>
  }
}
@if (produktionsmalPlan) {
  <rask-produktionsmal-plan-legend
    class="col-12"
    [detailMode]="isDetailMode()"
    [produktionsomraden]="produktionsomraden"
    [produktionsmalPlan]="produktionsmalPlan">
  </rask-produktionsmal-plan-legend>
}
@if (hsgTabs && hsgTabs.length > 0 && isDetailMode() && produktionsmalPlan) {
  <rask-tabs
    aid="produktionsmalPlan"
    class="child"
    [tabs]="hsgTabs" [selectedTab]="selectedHsgTab">
  </rask-tabs>
}
@if (produktionsmalPlan) {
  <rask-produktionsmal-plan-chart
    [produktionsmalPlan]="produktionsmalPlan"
    [produktionsmalPlanMode]="mode"
    [selectedHandelssortimentsgruppKod]="selectedHsgKod"
    [handelssortimentsgrupper]="handelssortimentsgrupper">
  </rask-produktionsmal-plan-chart>
}
